import { BrowserModule } from "@angular/platform-browser";
import {
  APP_INITIALIZER,
  ErrorHandler,
  LOCALE_ID,
  NgModule,
} from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { CommonModule, registerLocaleData } from "@angular/common";
import { RouterModule } from "@angular/router";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { StoreModule } from "@ngrx/store";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { StorageService } from "./helper/Services/storage.service";
import { UiStyleToggleService } from "./helper/Services/ui-style-toggle.service";
import { NgbTimeAdapter, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgbTimeStringAdapter } from "./helper/Services/NgbTimeStringAdapter.service";
import { reducers } from "./reducers";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import localar from "@angular/common/locales/ar-EG";
import { ErrorFireUiComponent } from "./helper/Controls/error-fire-ui/error-fire-ui.component";
import { ErrorFireService } from "./helper/Services/error-fire.service";
import { Httpconinter } from "./helper/Interceptor/httpconinter";
import { LoaderuiService } from "./helper/Services/loaderui.service";
import { LoaderspinComponent } from "./helper/Controls/loaderspin/loaderspin.component";
import { FullscreenalertComponent } from "./helper/Controls/fullscreenalert/fullscreenalert.component";
import { ExtentedHelper } from "./helper/Appcode/ExtentedHelper";
import { ConfirmDialogService } from "./helper/Services/confirm-dialog.service";
import { ConfirmdialogComponent } from "./helper/Controls/confirmdialog/confirmdialog.component";
import { AppConfigService, APP_CONFIG } from "./helper/Appcode/app-config.service";
import { NgxPermissionsModule } from "ngx-permissions";
import { GeoMapXService } from "./helper/Services/geo-map-x.service";
import { NgxFilesizeModule } from "ngx-filesize";
registerLocaleData(localar);
/**
 * Exported function so that it works with AOT
 * @param {AppConfigService} configService
 * @returns {Function}
 */
const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};
@NgModule({
  declarations: [
    AppComponent,
    ErrorFireUiComponent,
    LoaderspinComponent,
    FullscreenalertComponent,
    ConfirmdialogComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterModule,
    TooltipModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
    }),
    StoreModule.forRoot(reducers),
    NgxPermissionsModule.forRoot()
  ],
  exports: [],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService],
    },
    LoaderuiService,
    ExtentedHelper,
    UiStyleToggleService,
    ErrorFireService,
    StorageService,
    GeoMapXService,
    ConfirmDialogService,
    {
      provide: APP_INITIALIZER,
      useFactory: themeFactory,
      deps: [UiStyleToggleService],
      multi: true,
    },
    { provide: NgbTimeAdapter, useClass: NgbTimeStringAdapter },
    { provide: LOCALE_ID, useValue: "ar-EG" },
    { provide: HTTP_INTERCEPTORS, useClass: Httpconinter, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function themeFactory(themeService: UiStyleToggleService) {
  return () => themeService.setThemeOnStart();
}
